export class ModelBase {
  id: number;
}
